import React from 'react'

import { Attachment, AttachmentStatus, AttachmentType } from '../../../../../../../../@types/types'
import { InitState } from '../../../../../../../../redux/reducers/root/initialState'
import { useAppSelector } from '../../../../../../../../app/hooks'
import Video from './Video'

export const VideoList: React.FC = () => {
  const attachment = useAppSelector((state: InitState) =>
    state.multimediaFeature.attachments.find((it) => it.attachmentType === AttachmentType.VIDEO)
  )

  const attachmentUploadFinished = attachment && attachment.state === AttachmentStatus.PERSISTED

  return <>{attachmentUploadFinished && <Video videoAttachment={attachment.attachment as Attachment} />}</>
}

export default VideoList
